import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import invariant from 'redux-immutable-state-invariant';
import { autoRehydrate } from 'redux-persist';
// import localforage from 'localforage';
import { REHYDRATE } from 'redux-persist/constants'
import createActionBuffer from 'redux-action-buffer';
import rootReducer from '../reducers';

export default function configureStore(history) {
  let enhancer;
  const middleware = routerMiddleware(history);
  if (process.env.NODE_ENV === 'production') {
    enhancer = compose(
      autoRehydrate(),
      applyMiddleware(thunk, createActionBuffer(REHYDRATE), middleware),   
      // applyMiddleware(thunk, middleware),   
    )
  }
  else {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    enhancer = composeEnhancers(
      autoRehydrate(),
      applyMiddleware(invariant(), thunk, createActionBuffer(REHYDRATE), middleware),  
    )
  }
  const store = createStore(rootReducer, undefined, enhancer);
  if (module.hot) {
    module.hot.accept('../reducers', () =>
      store.replaceReducer(require('../reducers'))
    );
  }

  return store;
}